import React, {useState} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import {compose} from 'redux';
import Sidebar from "./sidebar";
import {ThunkCretorGetInfo} from '../../context/reducers/infoReducer';

function SidebarContainer(props)
{
    if(props.info.data==null) props.getInfo();

    let [isClosed, setIsClosed] = useState(false);

    let ToggleClick = (e) => {
        setIsClosed(!isClosed);
    }
    if (props.info.data)
    return (
        <Sidebar toggle={ToggleClick} isClosed = {isClosed} {...props.info.data}/>
    )
}

let mapStateToProps = (state) => ({
    info: state.info
});

const mapDispatchToProps = (dispatch)=>({
    getInfo: () => {
        dispatch(ThunkCretorGetInfo());
    }
});
export default compose(
connect(mapStateToProps, mapDispatchToProps)
)(SidebarContainer);